import React, { ReactNode } from 'react'
import { useAuthGuard } from './useAuthGuard'

interface Props {
  children: ReactNode
}

/**
 * Gates a route subtree on a valid session. While the auth state is
 * `checking` (sync token expired but a refresh might still succeed) or
 * `unauthenticated` (refresh failed, no session) the children don't
 * render. The guard also bootstraps the account cookies when missing so
 * downstream components can rely on `UserSession.getAccountId()` being
 * present at render time.
 */
const RefreshTokenWrapper: React.FC<Props> = ({ children }) => {
  const { ready } = useAuthGuard()

  if (!ready) return null

  return <>{children}</>
}

export default RefreshTokenWrapper
